// Share/brag strings for both Name That Guy dailies. Single source of truth so
// Jr. and Sr. read as one product: identical structure, tiered middle phrase,
// same tail everywhere.
// Sr. tier = hints revealed before the winning guess (one hint per wrong
// guess, so 0-2 on a win; a 3rd wrong guess is a loss).

const TAIL = 'Give it a floor run, see if it plays... knowyourguy.com';

export function ntgJrShareText(passed) {
  const phrase = passed ? 'Took care of business.' : "I don't know my guy today.";
  return `I just played the Name That Guy Jr. daily challenge 👶 on KYG... ${phrase} ${TAIL}`;
}

export function ntgSrShareText(won, hintsUsed) {
  const phrase = !won
    ? "I don't know my guy today."
    : hintsUsed <= 0 ? 'Cold blooded.'
    : hintsUsed === 1 ? 'Took care of business.'
    : 'Survived.';
  return `I just played the Name That Guy Sr. daily challenge 👴 on KYG... ${phrase} ${TAIL}`;
}
